module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Weather/Cloud-sun-4850c5ddfd4d411ed84fdb78f2dd49b4.svg";